





































































































































































































import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import Summary from '../../core/components/Summary.vue';
import Combobox from '../../core/components/Combobox.vue';
import ListFilters from '../../insurance/components/ListFilters.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import ModalInsuranceHarvest from '../components/ModalInsuranceHarvest.vue';
import Button from '../../core/components/Button.vue';
import Input from '../../core/components/Input.vue';
import { MultipleSelect } from '../../core/components';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper, AuthStoreHelper } from '../../core/mixins';
import { splitStringByIndex, EventBus, TypeEventBus, sortObjectByPropertyName, nestedFilter, getParameterFromUrl, goToUrl, PRIVILEGE_KEYS, getItemFromLocalStorage, existParams, getItemFromLocalStorageParsed, addItemToLocalStorage, removeItemFromLocalStorage, booleanFormatter, activeFormatter } from '../../core/utils/';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import {
    getCompanyItemById,
    getDateFromTimestamp,
    matchedIndexIdInArray,
    removeItemsFromList,
    parseFloatNumber
} from '../../core/utils';
import { format } from 'highcharts';
import { InsuranceServices } from '../api/InsuranceServices';
import moment from 'moment';
import { getUrlFarmingDetail } from '../utils';
import { paramsOptions } from '../models';
import { getValueAndUnit, unitsValuesChoices } from '../../../features/core/api';
import { HarvestRanchListFilters, InsuranceFilters } from '../api/models';
import Axios, { CancelTokenSource } from 'axios';
import { farmingsListProperties } from '../farming_models';
import { sortTypes } from '../../core/models/Table';

@Component({
    components: {
        Summary,
        Combobox,
        SimpleTable,
        ModalInsuranceHarvest,
        Button,
        Input,
        DeleteConfirmation,
        MultipleSelect,
        ListFilters
    }
})
export default class InsuranceHarvestManagement extends Mixins(
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    AuthStoreHelper
) {

    searchParams: HarvestRanchListFilters = {
        page: 1,
        page_size: 10,
    };
    searchRanchList: string = '';
    savedQueries: string[] = [];
    requestTokenInstance: CancelTokenSource = Axios.CancelToken.source();
    paginationTotalPages: number = 0;
    paginationTotalRows: number = 0;
    optionsFromResponse: farmingsListProperties | null = null;
    summaryResponse: any = null;
    
    @Watch('$_getInsuranceProperties', { immediate: true, deep: true })
    observableProperties() {
        this.assignPropertiesData();
    }

    updatesearchParams(page, itemsPerPage){
        this.searchParams.page = page;
        this.searchParams.page_size = itemsPerPage;
        this.searchParams.query = this.searchRanchList;
        this.findFarmings();
    }

    searchAction(params:InsuranceFilters){
        let pageSize = this.searchParams.page_size;
        this.searchParams.page = 1;
        this.searchParams = {
            page_size: pageSize,
            ...params
        };
        this.findFarmings();
    }

    

    updateTableOptions({sortBy, sortDesc, itemsPerPage, page}){
        this.searchParams.page_size = itemsPerPage;
        this.searchParams.page = page;
        if(sortBy.length ==  0){
            delete this.searchParams.sort_by;
            delete this.searchParams.sort_type;
        }else{
            let sortType = sortDesc[0] == true ? sortTypes.desc : sortTypes.asc;
            this.searchParams.sort_by = sortBy;
            this.searchParams.sort_type = sortType;
        }
        this.findFarmings();
        
    }

    findFarmings(){
        this.getFarmingList();
    }

    getFarmingList(){
        this.requestTokenInstance.cancel();
        this.requestTokenInstance = Axios.CancelToken.source();
        this.searchingFarmings(true);
        InsuranceServices.getFarmingList(
            this.requestTokenInstance, 
            this.searchParams
        )
        .then(res => {
            this.paginationTotalPages = res.totalPages;
            this.paginationTotalRows = res.count;
            this.optionsFromResponse = res.properties;
            this.setTableItems(res.data);
            this.searchingFarmings(false);
            this.summaryResponse = res.summary;
            this.updateSummary();
        })
        .catch(err => {
            if(err && err.message == 'Request canceled'){
                this.searchingFarmings(true);
                return;
            }
            this.paginationTotalPages = 1;
            this.paginationTotalRows = 0;
            this.setTableItems([]);
            this.searchingFarmings(false);
            if(err && err.response && err.response.data){
                this.$_catchLoadingDialog({
                    response: err.response.data || {},
                    alternative_msg: 'Ocurrió un error al obtener las zafras'
                });
            }
        })
    }


    clearInsuranceCompanies(){
        this.filtersInsuranceCompaniesSelected = [];
        if(this.multipleInsuranceCompanySelector){
            this.multipleInsuranceCompanySelector.clearOptionsSelected();
        }
    }

    get multipleInsuranceCompanySelector(): HTMLFormElement {
        return this.$refs.ihCompany as HTMLFormElement;
    }

    get getOptionsCompany() {
        if(this.filtersInsuranceCarrierSelected == null){
            return []
        }
        return this.filtersInsuranceCarrierSelected['secured_companies'];
    }

    get placeholderInsuranceCompany(){
        return this.filtersInsuranceCarrierSelected == null ? 'Seleccione una aseguradora' : 'Seleccionar'
    }


    @Watch('filtersInsuranceCarrierSelected')
    observableInsuranceCompanyChange(value) {
        this.setCompanyOptions(value);
    }

    advancedFilter(items, search, filter){
        return nestedFilter(items, search, filter)
    }

    savedFiltersCompanyList: Array<object>[] = [];
    filtersInsuranceCompaniesSelected: Array<object>[] = [];
    itemsCompanyHarvest: Array<object> = [];
    loadingItemsCompanyHarvest: boolean = false;
    loadingOptionsCompany: boolean = false;
    itemsInsuranceFarmings: Array<object> = [];
    farmingToDelete: object = {};
    insuranceFarmingToPatch: object = {};

    headers: any = [
        {
            text: 'Nombre',
            value: 'name',
            sortable: true
        },
        {
            text: 'Inicio',
            value: 'start_date',
            sortable: true,
            formatter: this.dateFormatter
        },
        {
            text: 'Fin',
            value: 'end_date',
            sortable: true,
            formatter: this.dateFormatter
        },
        {
            text: 'Empresa Aseguradora',
            value: 'insurance_company',
            sortable: true,
            formatter: this.insuranceCompanyFormatter,
            filter: this.filterInsuranceCompany
        },
        {
            text: 'Estado',
            value: 'active',
            sortable: true,
            formatter: this.statusFormatter,
            filter: this.filterActiveFarmings
        },
        {
            text: 'Tipo de cultivo',
            value: 'harvest_type',
            align: 'center',
            sortable: true,
            width: '130px',
            formatter: this.cropTypeFormatter,
            filter: this.filterByCropType
        },
        {
            text: 'Acciones',
            value: 'actions',
            align: 'center',
            sortable: true
        },
        {
            text: 'season',
            value: 'season',
            sortable: false,
            class: 'hide-header',
            filter: this.filterFarmingsBySeason,
            align: ' d-none'
        },
        {
            text: 'Año',
            value: 'year',
            sortable: false,
            class: 'hide-header',
            filter: this.filterFarmingsByYear,
            align: ' d-none'
        }
    ];

    headersCompany: any = [
        {
            text: 'Nombre',
            value: 'name',
            sortable: true
        },
        {
            text: 'Estado del cálculo',
            value: 'harvest_calculation_status',
            width: '90px',
            sortable: false
        },
        {
            text: 'Inicio',
            value: 'start_date',
            sortable: true,
            formatter: this.dateFormatter
        },
        {
            text: 'Fin',
            value: 'end_date',
            sortable: true,
            formatter: this.dateFormatter
        },
        {
            text: 'Empresa',
            value: 'company__name',
            sortable: true,
        },
        {
            text: 'Zafra Aseguradora',
            value: 'insurance_farming__name',
            sortable: true,
        },
        {
            text: 'Estado',
            value: 'state',
            sortable: true,
            formatter: (value) => {
                return activeFormatter(value)
            },
        },
        {
            text: 'Tipo de cultivo',
            value: 'harvest_type',
            align: 'center',
            sortable: true,
            width: '130px',
            formatter: this.cropTypeFormatter,
        },
        
        {
            text: 'Temporada',
            value: 'season',
            sortable: false,
        },
        {
            text: 'Acciones',
            value: 'actions',
            align: 'center',
            sortable: false
        },
       
    ];

    pendingRequestInsuranceFarming: boolean = false;
    customColumns: any = [
        {
            slotName: 'actions',
            itemValue: 'actions'
        }
    ];

    pageTitle: string = 'Gestión de Zafras';
    summaryData: any = [];
    cropTypeOptions: Array<object> = [];
    allCropTypeOptions: Array<object> = [];
    optionsCompany: Array<object> = [];
    optionsInsuranceCompany: Array<object> = [];

    //variable filters
    filtersCompanySelected: any = null;
    filtersInsuranceCarrierSelected: any = null;
    filtersStatus: any | null = null;
    filtersCropTypeSelected: any = null;
    filtersZafraTypeSelected: any = null;
    filtersZafraYear: any = null;
    searchInsuranceHarvest: string = '';
    searchHarvestCompany: string = '';

    //Modals
    visibleModalInsuranceHarvest: boolean = false;
    visibleModalCompanyHarvest: boolean = false;
    confirmationDelete: boolean = false;
    deleteModalTitle: string = 'Eliminar';
    editInsuranceHarvest: boolean = false;
    editCompanyHarvest: boolean = false;

    //selector reset values
    companyRV: boolean = false;
    filtersInsuranceCarrierRV: boolean = false;
    filtersStatusRV: boolean = false;
    cropTypeRV: boolean = false;
    filtersZafraTypeRv: boolean = false;
    filtersZafraYearRv: boolean = false;

    //Selector options
    // statusOptions: any = [
    //     {
    //         id: 1,
    //         description: 'Activas',
    //         value: true
    //     },
    //     {
    //         id: 2,
    //         description: 'Inactivas',
    //         value: false
    //     }
    // ];

    yearsOptions: Array<object> = [];
    insuranceCompanies: Array<object> = [];
    sortBy: string[] = [];
    sortDesc: boolean[] = [];
    companyFarmingPatchData: object = {};
    farmingTypeToDelete: string = '';

    filteredInsuranceCompany: Array<object> = [];
    filteredCompanyItems: Array<object> | null = null;
    hasParams: boolean = window.location.href.indexOf('?') !== -1 ? true : false;
    showInsurancePanel: boolean = false;
    counter: number = 0;
    propertiesData: object | null = null;

    get isCarrier(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER];
    }

    filtersSelectInsuranceCompany(itemToAdd) {
        this.filtersInsuranceCompaniesSelected.push(itemToAdd);
    }

    updateSavedFilters(value){
        this.savedQueries = value;
    }

    filtersRemoveInsuranceCompany(itemToRemove) {
        this.filtersInsuranceCompaniesSelected = this.filtersInsuranceCompaniesSelected.filter(item => item['id'] !== itemToRemove.id);
    }



    dateFormatter(value) {
        let date = moment(value);
        if (!date.isValid()) {
            return '-';
        } else {
            return getDateFromTimestamp(value);
        }
    }

    statusFormatter(value) {
        return value ? 'Activa' : 'Inactiva';
    }

    insuranceFarmingFormatter(farmingId) {
        let allInsuranceCompanies = this.$_getInsuranceProperties['insurance_farmings'];
        if (allInsuranceCompanies) {
            let companyIndex = allInsuranceCompanies.findIndex(item => item['id'] === farmingId);
            if (companyIndex !== -1) {
                return allInsuranceCompanies[companyIndex]['name'];
            }
        }
    }

    insuranceCompanyFormatter(companyId) {
        let allInsuranceCompanies = this.$_getInsuranceProperties['insurance_companies'];
        if (allInsuranceCompanies) {
            let companyIndex = allInsuranceCompanies.findIndex(item => item['id'] === companyId);
            if (companyIndex !== -1) {
                return allInsuranceCompanies[companyIndex]['name'];
            }
        }
    }

    cropTypeFormatter(cropTypeId) {
        let allCropTypes = this.$_getInsuranceProperties['harvest_type'];
        if (allCropTypes) {
            let cropTypeIndex = allCropTypes.findIndex(item => Number(item['id']) === cropTypeId);
            if (cropTypeIndex !== -1) {
                return allCropTypes[cropTypeIndex]['value'];
            }
        }
    }

    @Watch('isCarrier')
    observableIsCarrier() {
        this.hideColumnsForInsuranceCarrier();

    }

    mounted() {
        let self = this;
        
        EventBus.$on(TypeEventBus.INSURANCE_FARMING_UPDATE_FARMING_LIST, () => {
            this.assignPropertiesData();
            this.getFarmingList();
        });
        this.$nextTick(() => {
            this.hideColumnsForInsuranceCarrier();
            this.assignPropertiesData();
            this.getFarmingList();
        });
    }

    preselectNewestYear(){
        if(this.counter == 1 && this.yearsOptions.length > 0){
            let newestYear = this.yearsOptions[this.yearsOptions.length - 1];
            this.updateFiltersZafraYear(newestYear);
        }
    }

    preselectInsuranceCompany(optionsInsuranceCompany){
        /* Preseleccionar empresa aseguradora */
        let insuranceCompanyIdFromUrl = getParameterFromUrl(paramsOptions.insurance_company) !== null 
        ? Number(getParameterFromUrl(paramsOptions.insurance_company)) : null

        let insuranceCompanyFromStorage = getItemFromLocalStorage('mv_filters_aseguradora') !== null
                ? getItemFromLocalStorageParsed('mv_filters_aseguradora')['id']
                : null;
        let insuranceCompanyId:number | null = insuranceCompanyFromStorage;

        if(existParams() && insuranceCompanyIdFromUrl !== null){
            insuranceCompanyId = insuranceCompanyIdFromUrl;
        }

        if(insuranceCompanyId !== null){
            //si hay una aseguradora guardada en el local storage, la preselecciono
            let optIndex = optionsInsuranceCompany.findIndex(item => item['id'] == insuranceCompanyId);
            this.updateFiltersInsuranceCarrierSelected(optionsInsuranceCompany[optIndex]);
        }else{
            //si no hay una aseguradora guardada en el local storage, preselecciono la primera
            this.updateFiltersInsuranceCarrierSelected(optionsInsuranceCompany[0])
        }
    }



    hideColumnsForInsuranceCarrier(){
        if(this.isCarrier){
            this.headersCompany = this.headersCompany.filter(item => item['value'] !== 'harvest_calculation_status');
        }
    }


    getFarmingLink(item){
        return getUrlFarmingDetail(item['id'])
    }

    getDetailInsuranceFarming(farming) {
        let self = this;
        InsuranceServices.getInsuranceFarmingDetail(farming['id'])
            .then(res => {
                res['insurance_farming__id'] = farming['id'];
                self.insuranceFarmingToPatch = res;
                self.editInsuranceHarvest = true;
                self.visibilityModalInsuranceHarvest(true);
                self.$set(farming, 'isLoading', false);
            })
            .catch(error => {
                self.$set(farming, 'isLoading', false);
            });
    }

    searchingFarmings(value) {
        this.loadingItemsCompanyHarvest = value;
    }

    assignPropertiesData() {
        this.pendingRequestInsuranceFarming = true;
        let insuranceFarmings =
            this.$_getInsuranceProperties['insurance_farmings'] !== undefined
                ? this.$_getInsuranceProperties['insurance_farmings']
                : [];
        this.itemsInsuranceFarmings = insuranceFarmings;
        this.allCropTypeOptions = this.$_getInsuranceProperties['harvest_type'];
        this.pendingRequestInsuranceFarming = false;
        this.propertiesData = this.$_getInsuranceProperties;
        this.setInsuranceCompanies();
    }

    setActiveStatusFilter() {
        this.updateFiltersStatus({
            id: 1,
            description: 'Activas',
            value: true
        });
    }

    setTableItems(items) {
        this.itemsCompanyHarvest = items;
    }




    deleteInsuranceFarming() {
        this.pendingRequestInsuranceFarming = true;
        InsuranceServices.deleteInsuranceFarming(this.farmingToDelete['id'])
            .then(response => {
                this.removeInsuranceFarmingFromPropertiesList(this.farmingToDelete['id']);
                this.handleSuccessDeletion(response);
            })
            .catch(err => {
                this.handleCatchDeletion(err);
            });
    }

    removeInsuranceFarmingFromPropertiesList(farmingId: number){
        let insuranceFarmings = this.$_getInsuranceProperties['insurance_farmings'];
        let index = insuranceFarmings.findIndex(item => item['id'] == farmingId);
        insuranceFarmings.splice(index, 1);
        this.$_setInsuranceProperties({
            ...this.$_getInsuranceProperties,
            insurance_farmings: insuranceFarmings
        });
    }

    deleteCompanyFarming() {
        this.loadingItemsCompanyHarvest = true;
        InsuranceServices.deleteFarming(this.farmingToDelete['id'])
            .then(response => {
                this.findFarmings();
                // this.checkIfExistsOtherFarmingWithDeletedYear(this.farmingToDelete['year'])
                this.handleSuccessDeletion(response);
            })
            .catch(err => {
                this.handleCatchDeletion(err);
            });
    }

    deleteAction(value) {
        if (value) {
            if (this.farmingTypeToDelete === 'insurance') {
                //delete zafra de aseguradora
                this.deleteInsuranceFarming();
            } else if (this.farmingTypeToDelete === 'company') {
                //delete zafra de empresa
                this.deleteCompanyFarming();
            }
        }
        this.farmingTypeToDelete = '';
        this.confirmationDelete = false;
    }

    handleSuccessDeletion(response) {
        let self = this;
        this.farmingToDelete = {};
        if (response && response.data && response.data.message) {
            this.$_successDeleteRecipients(response['data']['message']);
        }
        let allItems = this.itemsInsuranceFarmings;
        this.itemsInsuranceFarmings = [];
        this.itemsInsuranceFarmings = allItems;
        setTimeout(() => {
            self.pendingRequestInsuranceFarming = false;
            self.loadingItemsCompanyHarvest = false;
        }, 500);
    }

    handleCatchDeletion(error) {
        if (error && error.response && error.response.data && error.response.data.message) {
            this.$_errorPatchRecipients(error.response.data.message);
        } else {
            this.$_errorPatchRecipients('No se pudo eliminar la zafra');
        }
        this.pendingRequestInsuranceFarming = false;
        this.loadingItemsCompanyHarvest = false;
    }

    visibilityModalInsuranceHarvest(value) {
        this.visibleModalInsuranceHarvest = value;
    }

    visibilityModalCompanyHarvest(value) {
        this.visibleModalCompanyHarvest = value;
    }

    updateFiltersCompanySelected(value) {
        this.filtersCompanySelected = value;
    }

    updateFiltersCompanyRV(value) {
        this.companyRV = value;
    }

    updateFiltersInsuranceCarrierSelected(value) {
        this.filtersInsuranceCarrierSelected = value;
        if (value !== null) {
            addItemToLocalStorage('mv_filters_aseguradora', value);
        } else {
            this.updateFiltersCompanySelected(null);
            removeItemFromLocalStorage('mv_filters_aseguradora');
        }
        this.clearInsuranceCompanies();
    }

    updateFiltersInsuranceCarrierRV(value) {
        this.filtersInsuranceCarrierRV = value;
    }

    updateFiltersStatus(value) {
        this.filtersStatus = value;
    }

    updateFiltersStatusRV(value) {
        this.filtersStatusRV = value;
    }

    updateFiltersCropType(value) {
        this.filtersCropTypeSelected = value;
    }

    updateFiltersCropTypeRV(value) {
        this.cropTypeRV = value;
    }

    updateFiltersZafraType(value) {
        this.filtersZafraTypeSelected = value;
    }

    updateFiltersZafraTypeRV(value) {
        this.filtersZafraTypeRv = value;
    }

    updateFiltersZafraYear(value) {
        this.filtersZafraYear = value;
    }

    updateFiltersZafraYearRV(value) {
        this.filtersZafraYearRv = value;
    }

    updateInsuranceSearchValue(value) {
        this.searchInsuranceHarvest = value;
    }

    updateCompanySearchValue(value) {
        this.searchHarvestCompany = value;
    }

    updateSummary() {
        //summary de la respuesta WS de zafras
        let summary = this.summaryResponse;
        let total_zafras = summary.total_farmings,
            zafras_activas = summary.total_farmings_active,
            chacras_finalizadas = summary.total_ranchs_finished,
            area_cosecha = summary.total_harvest_area,
            cosechadoras = summary.total_harvest_vehicles,
            zafras_inactivas = summary.total_farmings_inactive,
            chacras_en_curso = summary.total_ranchs_unfinished,
            area_siembra = summary.total_sowing_area,
            sembradoras = summary.total_sowing_vehicles,
            polizas = summary.total_policies;

        this.setSummaryData(
            total_zafras,
            zafras_activas,
            chacras_finalizadas,
            area_cosecha,
            cosechadoras,
            zafras_inactivas,
            chacras_en_curso,
            area_siembra,
            sembradoras,
            polizas
        );
    }

    removeDuplicatedFromObject(object) {
        let uniqueObject = object.filter(function(item, pos) {
            return object.indexOf(item) == pos;
        });
        return uniqueObject;
    }

    setSummaryData(
        total: number,
        actives: number,
        finishedRanches: number,
        harvestTotalArea: number,
        harvestVehicles: number,
        inactives: number,
        unfinishedRanches: number,
        sowingTotalArea: number,
        sowingVehicles: number,
        policies: number
    ) {
        this.summaryData = [
            {
                text: 'Total de Zafras',
                value: total
                // icon: {
                //     name: 'mdi-pound',
                //     color: 'primary'
                // }
            },
            {
                text: 'Zafras Activas',
                value: actives
                // icon: {
                //     name: 'mdi-pound',
                //     color: 'primary'
                // }
            },
            {
                text: 'Chacras finalizadas',
                value: finishedRanches
                // icon: {
                //     name: 'mdi-pound',
                //     color: 'primary'
                // }
            },
            {
                text: 'Area cosecha',
                value: getValueAndUnit(harvestTotalArea, unitsValuesChoices.area)
                // icon: {
                //     name: 'mdi-pound',
                //     color: 'primary'
                // }
            },
            {
                text: 'Cosechadoras',
                value: harvestVehicles
                // icon: {
                //     name: 'mdi-pound',
                //     color: 'primary'
                // }
            },
            {
                text: 'Zafras Inactivas',
                value: inactives
                // icon: {
                //     name: 'mdi-pound',
                //     color: 'primary'
                // }
            },
            {
                text: 'Chacras en curso',
                value: unfinishedRanches
                // icon: {
                //     name: 'mdi-pound',
                //     color: 'primary'
                // }
            },
            {
                text: 'Area siembra',
                value: getValueAndUnit(sowingTotalArea, unitsValuesChoices.area)
                // icon: {
                //     name: 'mdi-pound',
                //     color: 'primary'
                // }
            },
            {
                text: 'Sembradoras',
                value: sowingVehicles
                // icon: {
                //     name: 'mdi-pound',
                //     color: 'primary'
                // }
            },
            {
                text: 'Polizas',
                value: policies
                // icon: {
                //     name: 'mdi-pound',
                //     color: 'primary'
                // }
            }
        ];
    }

    deleteInsuranceHarvest(item) {
        this.farmingTypeToDelete = 'insurance';
        this.deleteModalTitle = 'Eliminar Zafra de Aseguradora';
        this.farmingToDelete = item;
        this.confirmationDelete = true;
    }

    deleteCompanyHarvest(item) {
        this.farmingTypeToDelete = 'company';
        this.deleteModalTitle = 'Eliminar Zafra de Empresa';
        this.farmingToDelete = item;
        this.confirmationDelete = true;
    }

    createInsuranceHarvest() {
        this.editInsuranceHarvest = false;
        this.visibilityModalInsuranceHarvest(true);
    }

    modifyInsuranceHarvest(item) {
        //get insurance farming detail
        this.$set(item, 'isLoading', true);
        this.getDetailInsuranceFarming(item);
    }

    createCompanyHarvest() {
        goToUrl(getUrlFarmingDetail(null))
    }


    addNewCompanyFarming(newItem) {
        this.getFarmingList();
    }

    updateCompanyFarming(updatedItem) {
        let indexItemToUpdate = matchedIndexIdInArray(this.itemsCompanyHarvest, updatedItem['id']);
        if (indexItemToUpdate !== -1) {
            this.$set(this.itemsCompanyHarvest[indexItemToUpdate], 'company', updatedItem['company']);
            this.$set(this.itemsCompanyHarvest[indexItemToUpdate], 'active', updatedItem['active']);
            this.$set(this.itemsCompanyHarvest[indexItemToUpdate], 'start_date', updatedItem['start_date']);
            this.$set(this.itemsCompanyHarvest[indexItemToUpdate], 'end_date', updatedItem['end_date']);
            this.$set(this.itemsCompanyHarvest[indexItemToUpdate], 'harvest_type', updatedItem['harvest_type']);
            this.$set(this.itemsCompanyHarvest[indexItemToUpdate], 'id', updatedItem['id']);
            this.$set(
                this.itemsCompanyHarvest[indexItemToUpdate],
                'insurance_farming',
                updatedItem['insurance_farming']
            );
            this.$set(this.itemsCompanyHarvest[indexItemToUpdate], 'name', updatedItem['name']);
            this.$_successPatchRecipients('Zafra de Empresa modificada');
        }
    }

    @Watch('optionsInsuranceCompany', { immediate: true})
    observableOptionsInsuranceCompany(options) {
        if(this.counter == 0){
            this.preselectInsuranceCompany(options);
        }
    }

    setInsuranceCompanies() {
        let insuranceCompanies = this.$_getInsuranceProperties['insurance_companies'];
        this.optionsInsuranceCompany = insuranceCompanies;
    }

    setCompanyOptions(insuranceSelected) {
        this.loadingOptionsCompany = true;
        let companyOptions: Array<object> = [];
        if (insuranceSelected !== null) {
            let companyIndex = this.optionsInsuranceCompany.findIndex(
                item => item['company'] === insuranceSelected['company']
            );

            if (companyIndex !== -1) {
                companyOptions = this.optionsInsuranceCompany[companyIndex]['secured_companies'];
            }
        }
        this.optionsCompany = companyOptions;
        this.loadingOptionsCompany = false;
    }

    filterActiveFarmings(value) {
        if(this.searchParams.hasOwnProperty('state')){
            let paramsStateValue = this.searchParams['state'] == 0 ? false : true;
            return value == paramsStateValue
        }

        return true
    }

    filterInsuranceCompany(value) {
        return this.searchParams.hasOwnProperty('insurance_company') ? value === this.searchParams['insurance_company'] : true;
    }


  

    filtersByCompanySelected(companyName) {
        /* Filtro por empresa aseguradora */
        if(this.filtersInsuranceCompaniesSelected.length == 0){
            return true
        }
        
        let indexCompanyNameInFilteredOptions = this.filtersInsuranceCompaniesSelected.findIndex(item => item['name'] === companyName)
        if(indexCompanyNameInFilteredOptions !== -1){
            return this.filtersInsuranceCompaniesSelected[indexCompanyNameInFilteredOptions]
        }
    }

    filterByCropType(value) {
        return this.searchParams.hasOwnProperty('harvest_type') ? value === Number(this.searchParams['harvest_type']) : true;
    }

    filterFarmingsBySeason(value) {
        if( this.searchParams.hasOwnProperty('season')){
            let seasonValue = this.searchParams['season'] == 0 ? 'Verano' : 'Invierno';
            return value == seasonValue
        }
        return true;
    }

    filterFarmingsByYear(value) {
        return this.searchParams.hasOwnProperty('year') ? value === this.searchParams['year'] : true;
    }

    filteredItemsInsuranceCompany(items) {
        this.filteredInsuranceCompany = items;
    }

    filteredItemsCompany(items) {
        
        this.filteredCompanyItems = items;
    }

    backToInsurance() {
        this.$router.push(NAME_ROUTES.INSURANCE.path);
    }

    toggleInsuranceFarmingList() {
        let isVisible = !this.showInsurancePanel;
        this.showInsurancePanel = isVisible;
        this.updateSummary()
    }
}
